import { Nullable } from "../types/types";

export const intersectList = <T>(listA: T[], listB: T[]): T[] => {
	return listA.reduce<T[]>((c, a) => {
		if (listB.includes(a)) c.push(a);

		return c;
	}, []);
};

export const arrayIsSame = <T>(listA: T[] = [], listB: T[] = []): boolean => {
	if (listA.length !== listB.length) return false;
	const intersected = intersectList(listA, listB);

	return intersected.length === listA.length;
};

export const removeEmptyData = <T>(data: Nullable<T>[]) =>
	data.filter((single) => single !== undefined && single !== null);

export const uniqueArray = <T>(data: T[]) => {
	return Array.from(new Set<T>(data));
};
